import { z } from '@/libs/zod';

export const affiliateSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
});

export const affiliateResponseSchema = z.object({
  data: z.array(affiliateSchema),
});

export type Affiliate = z.infer<typeof affiliateSchema>;
export type AffiliateResponse = z.infer<typeof affiliateResponseSchema>;
